export enum CustomPropertyDatatype {
	NUMBER = 'NUMBER', //All number are unit numbers from now on
	STRING = 'STRING',
	SELECT = 'SELECT',
	MULTI_SELECT = 'MULTI_SELECT',
	BOOLEAN = 'BOOLEAN',
	MULTI_STRING = 'MULTI_STRING',
	GEOLOCATION = 'GEOLOCATION',
	TIMESTAMP = 'TIMESTAMP',
	PROCESS = 'PROCESS',
}

export enum CustomPropertyType {
	BOOLEAN = 'BOOLEAN',
	DATE = 'DATE',
	EMAIL = 'EMAIL',
	LOCATION = 'LOCATION',
	MULTI_SELECT = 'MULTI_SELECT',
	NUMBER = 'NUMBER',
	PHONE = 'PHONE',
	PROCESS = 'PROCESS',
	SINGLE_SELECT = 'SINGLE_SELECT',
	TEXT_ARRAY = 'TEXT_ARRAY',
	TEXT = 'TEXT',
	TIME = 'TIME',
	URL = 'URL',
	USER = 'USER',
}
